module.exports = __webpack_public_path__ + "img/logo-pinosvl.9252938b.png";